import React from 'react'
import { connect } from 'react-redux'
import styled, { css } from 'styled-components'

import { mapLanguageToComponentProps } from 'i18n'
import { Icon } from 'components/styled/icon'
import { I18nComponentType } from 'i18n-types'
import { SmallStyle } from 'components/styled/typography/styles'

interface MessageDeliveryStatusProps {
  i18n: I18nComponentType
  bounceType?: string
  bounceSubType?: string
  smsStatus?: string
}

const StatusIcon = styled(Icon)<{ $iconClass?: string }>`
  ${({ $iconClass }) =>
    $iconClass === 'Permanent' &&
    css`
      color: ${({ theme }) => theme.color.error110};
    `}

  ${({ $iconClass }) =>
    ($iconClass === 'Undetermined' || $iconClass === 'Transient') &&
    css`
      color: ${({ theme }) => theme.color.warn110};
    `}
`

const StyledMessageDeliveryStatus = styled.div<{ $iconClass?: string }>`
  ${SmallStyle};
  font-style: italic;

  display: flex;
  align-items: center;

  span {
    margin-left: ${({ theme }) => theme.space.s4};
  }

  ${({ $iconClass }) =>
    $iconClass === 'Permanent' &&
    css`
      color: ${({ theme }) => theme.color.error130};
    `}

  ${({ $iconClass }) =>
    ($iconClass === 'Undetermined' || $iconClass === 'Transient') &&
    css`
      color: ${({ theme }) => theme.color.warn130};
    `}
`

const getSmsStatusTextaAndIconClass = (
  i18n: I18nComponentType,
  smsStatus?: string
) => {
  if (!smsStatus) {
    return {
      text: undefined,
      iconClass: undefined,
    }
  }

  if (smsStatus === 'failed') {
    return {
      text: i18n.smsDeliveryStatus.failed,
      iconClass: 'Permanent',
    }
  }
  if (smsStatus === 'failed - duplicate number') {
    return {
      text: `${i18n.smsDeliveryStatus.failed} ${i18n.smsDeliveryStatus.duplicate}`,
      iconClass: 'Permanent',
    }
  }
  return {
    text: i18n.smsDeliveryStatus.notDelivered,
    iconClass: 'Transient',
  }
}

export function MessageDeliveryStatus({
  i18n,
  bounceType = '',
  bounceSubType = '',
  smsStatus = undefined,
}: MessageDeliveryStatusProps) {
  if (smsStatus && smsStatus === 'delivered') {
    return <div />
  }

  const smsTextAndBounceType = getSmsStatusTextaAndIconClass(i18n, smsStatus)

  // TODO fix hacky solution
  const statusTranslations = i18n.emailDeliveryStatus as {
    [key: string]: { [subKey: string]: string | undefined } | undefined
  }

  const text = smsStatus
    ? smsTextAndBounceType.text
    : statusTranslations[bounceType]?.[bounceSubType]

  const iconClass = smsStatus ? smsTextAndBounceType.iconClass : bounceType

  return (
    <StyledMessageDeliveryStatus $iconClass={iconClass}>
      <StatusIcon type="info" size="s16" $iconClass={iconClass} />
      <span>{text}</span>
    </StyledMessageDeliveryStatus>
  )
}

export default connect<{
  i18n: I18nComponentType
}>(mapLanguageToComponentProps())(MessageDeliveryStatus)
